import styled from 'styled-components';
import COLORS from '../../../style/universal.color';

const {
    starsBlue,
    mlbGrey3,
    focusedBlue
} = COLORS;

interface NavItemWrapperProps {
    active: boolean;
}

export const NavItemWrapper = styled.li`
    > a,
    > div {
    color: ${({active}: NavItemWrapperProps) => active ? starsBlue : mlbGrey3};
    cursor: pointer;
    font-weight: bold;
        &:focus {
            outline: 1px auto ${focusedBlue};
        }
        &:hover {
            color: ${({active}: NavItemWrapperProps) => !active && COLORS['mlbGrey4']};
        }
    }
`;